import { Paper } from "@mui/material";
import AiLayout_Header from "./components/AiLayout_Header";
import AiLayout_Prompt from "./components/AiLayout_Prompt";
import AiLayout_Submit from "./components/AiLayout_Submit";
import AiLayout_Responses from "./components/AiLayout_Responses";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import { useAi } from "src/context/AiContext";

export default function AiLayout() {
  const { isLoading } = useAi();
  return (
    <div className="center" style={{ minHeight: "60vh", marginTop: 12 }}>
      <Paper className="center paperBox" style={{ width: "100%", flexDirection: "column" }}>
        <AiLayout_Responses />
        <AiLayout_Header />
        <AiLayout_Prompt />
        <ProgressBar show={isLoading} height={3} />
        <AiLayout_Submit />
      </Paper>
    </div>
  );
}
